module.exports = __webpack_public_path__ + "img/1e80743.png";